import { SCREENS } from "utils/constants";
import List from "./List";

const routes = [
  {
    path: "/admin/crm/leads",
    exact: true,
    element: <List />,
  },
];

export default routes;
